import {
  Avatar,
  FlexBox,
  IconButton,
  Text,
  Tooltip,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { HTMLAttributes } from 'react';

import { type MimSidekickMode } from '../../mimSidekickWidget';
import { MimSidekickHistory } from '../mimSidekickHistory/mimSidekickHistory';

import styles from './mimSidekickHeader.module.scss';

type MimSidekickHeaderProps = {
  onMinimize: () => void;
  mode: MimSidekickMode;
  onToggleMode: () => void;
  isDevModeAvailable: boolean;
  isDevMode: boolean;
  onToggleDevMode: () => void;
  dragHandleProps?: Pick<
    HTMLAttributes<HTMLDivElement>,
    'onPointerDown' | 'className'
  >;
};

export const MimSidekickHeader = ({
  onMinimize,
  mode,
  onToggleMode,
  isDevModeAvailable,
  isDevMode,
  onToggleDevMode,
  dragHandleProps,
}: MimSidekickHeaderProps): JSX.Element => {
  const isDocked = mode === 'docked';

  return (
    <FlexBox
      justifyContent="space-between"
      alignItems="center"
      {...dragHandleProps}
      className={classnames(styles.sidekickHeader, dragHandleProps?.className)}
    >
      <FlexBox gap="200" alignItems="center">
        <Avatar
          size="32"
          icon="mim-sidekick"
          color={{
            contentColor: 'var(--dixa-color-purple-900)',
            backgroundColor: 'var(--dixa-color-purple-200)',
          }}
        />
        <Text.Heading variant="heading-4">Mim Sidekick</Text.Heading>
      </FlexBox>
      <FlexBox gap="100" alignItems="center">
        {isDevModeAvailable && (
          <Tooltip content="Dev mode">
            <IconButton
              icon="code"
              variant={isDevMode ? 'primary' : 'secondary'}
              onClick={onToggleDevMode}
            />
          </Tooltip>
        )}
        <MimSidekickHistory />
        <Tooltip content={isDocked ? 'Floating' : 'Sidebar'}>
          <IconButton
            icon={isDocked ? 'floating' : 'docked'}
            variant="secondary"
            onClick={onToggleMode}
          />
        </Tooltip>
        <Tooltip content="Minimize">
          <IconButton icon="minus" variant="secondary" onClick={onMinimize} />
        </Tooltip>
      </FlexBox>
    </FlexBox>
  );
};
